export const calcMetrics = () => {
  typeof window.ym !== 'undefined'
    ? window.ym(30430687, 'reachGoal', 'calcUse')
    : console.log('Метрика не инициализирована');
};

export const leasingFormLoad = () => {
  typeof window.ym !== 'undefined'
    ? window.ym(30430687, 'reachGoal', '2025LeasingFormLoad')
    : console.log('Метрика не инициализирована');
};

export const leasingFormFilled = () => {
  typeof window.ym !== 'undefined'
    ? window.ym(30430687, 'reachGoal', '2025LeasingFormFilled')
    : console.log('Метрика не инициализирована');
};

export const leasingFormDone = () => {
  typeof window.ym !== 'undefined'
    ? window.ym(30430687, 'reachGoal', '2025LeasingFormDone')
    : console.log('Метрика не инициализирована');
};

export const footerForm = () => {
  typeof window.ym !== 'undefined'
    ? window.ym(30430687, 'reachGoal', '2025footerform')
    : console.log('Метрика не инициализирована');
};

export const orderCall = () => {
  typeof window.ym !== 'undefined'
    ? window.ym(30430687, 'reachGoal', '2025ordercall')
    : console.log('Метрика не инициализирована');
};

export const getOffer = () => {
  typeof window.ym !== 'undefined'
    ? window.ym(30430687, 'reachGoal', '2025getoffer')
    : console.log('Метрика не инициализирована');
};

export const wantBePartner = () => {
  typeof window.ym !== 'undefined'
    ? window.ym(30430687, 'reachGoal', '2025wantbepartner')
    : console.log('Метрика не инициализирована');
};

export const leasingFormGoToLK = () => {
  typeof window.ym !== 'undefined'
      ? window.ym(30430687, 'reachGoal', '2025LeasingFormGoToLK')
      : console.log('Метрика не инициализирована');
};

export const leasingFormGoToTid = () => {
  typeof window.ym !== 'undefined'
      ? window.ym(30430687,'reachGoal','2025LeasingFormGoToTID')
      : console.log('Метрика не инициализирована');
};

export const leasingFormLoadFullForm = () => {
  typeof window.ym !== 'undefined'
      ? window.ym(30430687, 'reachGoal', '2025LeasingFormLoadFullForm')
      : console.log('Метрика не инициализирована');
};